export default [
  {
    "languages": ["javascript", "typescript"],
    "hints": [
      {"displayText": "Anonymous Function", "text": "function () {\n\t\n}"},
      {"displayText": "Function", "text": "function functionName() {\n\t\n}"},
      {"displayText": "for", "text": "for (var i = 0; i < array.length; i++) {\n\tarray[i]\n}"},
      {"displayText": "if", "text": "if (true) {\n\t\n}"},
      {"displayText": "else", "text": "else {\n\t\n}"},
      {"displayText": "else if", "text": "else if (true) {\n\t\n}"},
      {"displayText": "log", "text": "console.log();"},

      {"displayText": "Start Function", "text": "function start() {\n\t\n}"},
      {"displayText": "Update Function", "text": "function update(now, deltaTime) {\n\t\n}"},
      {"displayText": "Fixed Update Function", "text": "function fixedUpdate(now, deltaTime) {\n\t\n}"},
      {"displayText": "Trigger Function", "text": "function trigger() {\n\t\n}"},
      {"displayText": "On Collision Function", "text": "function onCollision(other) {\n\t\n}"},
      {"displayText": "Destroy GameObject", "text": "gameObject.destroy();"},
      {"displayText": "Animator Play", "text": "gameObject.animator.play(animationName);"},
      {"displayText": "Animator Pause", "text": "gameObject.animator.pause();"},
      {"displayText": "Transform Position", "text": "gameObject.transform.position"},
      {"displayText": "Transform Rotation", "text": "gameObject.transform.rotation"},
      {"displayText": "Transform Scale", "text": "gameObject.transform.scale"},
      {"displayText": "Audio Background Play", "text": "Game.audio.background.play('audio.mp3');"},
      {"displayText": "Audio SFX Play", "text": "Game.audio.sfx.play('audio.mp3');"},
      {"displayText": "InputForm Text", "text": "InputForm.text('Label', defaultValue)"},
      {"displayText": "InputForm Checkbox", "text": "InputForm.checkbox('Label', defaultValue)"},
      {"displayText": "InputForm Select", "text": "InputForm.select('Label', [options], defaultValue)"},
      {"displayText": "InputForm File", "text": "InputForm.file('Label', [extensions], defaultValue)"},
      {"displayText": "Instantiate GameObject", "text": "Game.instantiate(prefab);"},
    ]
  },
  {
    "languages": ["html"],
    "hints": [
      {"displayText": "Vue Template", "text": "<template lang=\"html\">\n\n</template>\n\n<script>\nmodule.exports = {\n};\n</script>\n\n<style lang=\"css\" scoped>\n</style>"},
    ]
  }
]
